// AppHeader.js
import React from 'react';
import styles from './ChatApp.module.css';

// Icons
const DashboardIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="3" y="3" width="7" height="9"></rect><rect x="14" y="3" width="7" height="5"></rect><rect x="14" y="12" width="7" height="9"></rect><rect x="3" y="16" width="7" height="5"></rect></svg>
);
const AdminIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
);
const ChatIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
);
const OrderIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline></svg>
);


const AppHeader = ({ currentUser, allStores, selectedStore, onStoreSelect, onLogout, currentView, onNavigate }) => {
    const userType = currentUser.type.replace('_', ' ');

    return (
        <div className={styles.appHeader}>
            <div className={styles.headerLogo}>
                <div className={styles.loginLogo}>AirGrocer AI</div>
            </div>
            
            <div className={styles.adminNav}>
                {/* Chat (All Users) */}
                <button 
                    className={`${styles.navButton} ${currentView === 'chat' ? styles.navButtonActive : ''}`} 
                    onClick={() => onNavigate('chat')}
                >
                    <ChatIcon /> <span>Chat</span>
                </button>
                
                <button 
                    className={`${styles.navButton} ${currentView === 'dashboard' ? styles.navButtonActive : ''}`} 
                    onClick={() => onNavigate('dashboard')}
                >
                    <DashboardIcon /> <span>Dashboard</span>
                </button>

                {currentUser.type === 'distributor' && (
                    <>
                        <button 
                            className={`${styles.navButton} ${currentView === 'orders' ? styles.navButtonActive : ''}`} 
                            onClick={() => onNavigate('orders')}
                        >
                            <OrderIcon /> <span>Orders</span>
                        </button>
                        <button 
                            className={`${styles.navButton} ${currentView === 'admin' ? styles.navButtonActive : ''}`} 
                            onClick={() => onNavigate('admin')}
                        >
                            <AdminIcon /> <span>Admin</span>
                        </button>
                    </>
                )}
            </div>

            <div className={styles.headerUser}>
                Logged in as: <strong>{currentUser.name}</strong> ({userType})
                <button onClick={onLogout} className={styles.logoutButton} title="Logout">Logout</button>
            </div>
            
            {(currentUser.type === 'sales_rep' || currentUser.type === 'distributor') && (
                <div className={styles.storeSelector}>
                    <label htmlFor="store-select"><strong>Ordering for: </strong></label>
                    <select
                        id="store-select"
                        className={styles.storeSelectInput}
                        value={selectedStore ? selectedStore._id : ''}
                        onChange={(e) => {
                            const store = allStores.find(s => s._id === e.target.value);
                            onStoreSelect(store || null);
                        }}
                    >
                        <option value="">-- Select a Store --</option>
                        {allStores.map(store => (
                            <option key={store._id} value={store._id}>
                                {store.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

export default AppHeader;